import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConstantConfigService } from '../services/constant-config.service';
import { AuthenticationService } from '../services/authentication.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { ToastrService } from 'ngx-toastr';
import {GeneralService} from '../services/general.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    _accessToken: string = "";
    decodedToken: any = {};

    constructor(private router: Router, private authService: AuthenticationService,public jwtHelper: JwtHelperService,private toaster : ToastrService,private generalService : GeneralService,) {
      this._accessToken = ConstantConfigService.accessToken;
     }



    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):boolean {
      //var fullRoute = this.router.url;
      //console.log("fullRoute============================",fullRoute,state.url);
      if(state.url.indexOf('slack') > -1 || state.url.indexOf('tmdAI') > -1){
        const myToken = localStorage.getItem(this._accessToken);
        if(typeof myToken!="undefined" && myToken!=null && myToken!="null" && myToken!=""){
          // No Action
        }else{
          location.href = decodeURI("https://slack.com/openid/connect/authorize?scope=openid%20email%20profile&response_type=code&redirect_uri=https%3A%2F%2Fnew.trackmydocs.co%2Fuser-signin&client_id=386552275970.6673805699952");
        }
      }
        //const expectedRole = route.data;
        //console.log('expectedRole',expectedRole);
        //console.log('auth guard token',myToken);
        /*if (localStorage.getItem(this._accessToken)) {
            this.decodedToken = this.jwtHelper.decodeToken(myToken);
            console.log('decoded token',this.decodedToken);
            // logged in so return true
            return true;
        }*/
        const myToken = localStorage.getItem(this._accessToken);
        
        console.log(myToken);
        if(typeof myToken!="undefined" && myToken!="" && myToken!=null && myToken!="undefined"){
          this.decodedToken = this.jwtHelper.decodeToken(myToken);
        }else{
          this.decodedToken = null;
        }
        

        console.log('decodedToken ',this.decodedToken);
        if(typeof this.decodedToken!="undefined" && this.decodedToken!=null){
          //alert(1);
          const expectedRole = route.data.expectedRole;
          const role_id = this.decodedToken.userdata.role_id;
          console.log('decoded token',this.decodedToken);
          console.log('expectedRole ',expectedRole);
          console.log('role_id ',role_id);
          //|| this.decodedToken.role_id != expectedRole
          console.log('check role exist',expectedRole.includes(role_id));
          if ((!this.authService.isAuthenticated() || !expectedRole.includes(role_id)) && expectedRole != '' && typeof expectedRole !='undefined') {
            if(!this.authService.isAuthenticated()){
              this.authService.logout();
              this.generalService.showToasterErrorMessage("Please log in again for access to your account.");
              this.router.navigate(['/login']);
            } else if(!expectedRole.includes(role_id)){
              this.generalService.showToasterErrorMessage("Please log in again for access to your account.");
              this.router.navigate(['/overview']);
            }
            // not logged in so redirect to login page with the return url
            return false;
          }
          return true;
        }else{
         // alert(2);
	        var fullRoute = this.router.url;
          console.log("fullRoute============================",fullRoute);
          if (fullRoute.indexOf('quick-flow') > -1 || fullRoute == '/'){
              this.generalService.showToasterErrorMessage("Please login first to access the page");
              this.router.navigate(['/login']);
          } else {
            this.generalService.showToasterErrorMessage("Please log in again for access to your account.");
            this.router.navigate(['/login']);
          }
          //this.toaster.error("","User is unauthorized to access the page");
          //this.router.navigate(['/login']);
        }
        
    }


}
